export const sinisterConstants = {
  LIST_SINISTERS_REQUEST: 'LIST_SINISTERS_REQUEST',
  LIST_SINISTERS_SUCCESS: 'LIST_SINISTERS_SUCCESS'
};
